<template>
  <el-aside>
    <div class="aside_bg">
      <el-menu :default-active="myMenuActiveId" class="el-menu-vertical-demo">
        <div class="UserCenterTitle">
          <i class="el-icon-user-solid"></i>学者中心
        </div>
        <el-menu-item index="1">
          <router-link :to="{ path: '/myEvents' }">
            <i class="el-icon-menu"></i>
            <span style="line-height: 55px">我的会议</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="{ path: '/myInfo' }">
            <i class="el-icon-document"></i>
            <span style="line-height: 55px">个人信息</span>
          </router-link>
        </el-menu-item>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: 'UserMenu',
  props: {
    myMenuActiveId: String,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped></style>
